<template>
    <div>
      <section>
        <div class="inner row5">
          <div class="title">
            <h1>AgeTech산업사회 기여를 위한 교육영상 수정</h1>
          </div>
          <section>
            <div class="row4">
              <div class="aRow5">
                <div class="flex flexAlignS bdBttom">
                  <div class="detailInputBox">
                    <label>제목</label>
                    <input
                      ref="title"
                      v-model="saveData.title"
                      placeholder="제목을 작성해주세요."
                      maxlength="85"
                      style="width: 600px;"
                    />
                  </div>
                  
                </div>
                <!-- <Editor ref="editor"></Editor> -->
                <div class="detailTxtBox">
                  <textarea
                    class="detailTxtBoxItem"
                    placeholder="내용을 입력해주세요."
                    v-model="saveData.content"
                  ></textarea>
                </div>
                <div class="detailInputBox flex flexAlignL">
                    <label>공개설정</label>
                    <select v-model="saveData.privateOption"  class="selectCustom">
                      <option v-for="(option, index) in privateOptions" :key="index" :value="option.text">
                        {{ option.text }}
                      </option>
                    </select>
                </div>
                <div class="detailInputBox flex flexAlignL">
                    <label>카테고리</label>
                    <select v-model="saveData.category"  class="selectCustom">
                      <option v-for="(option, index) in categoryList" :key="index" :value="option.IDX">
                        {{ option.TITLE }}
                      </option>
                    </select>
                </div>
                <div class="detailInputBox flex flexAlignL">
                    <label>영상링크</label>
                    <div class="linkInputWrap">
                        <input type="text" class="linkInput" v-model="saveData.linkText"/>
                    </div>    
                </div>
                <div class="detailInputBox flex flexAlignL">
                    <label>영상 업로드</label>
                    <div class="detailFileInputBox">
                        <SingleVideoFileUpload
                            v-bind:saveData="saveData"
                            @set-file="setFile"
                        ></SingleVideoFileUpload>
                    </div>
                </div>
                <div class="detailInputBox flex flexAlignL">
                    <label>썸네일 업로드</label>
                    <div class="detailFileInputBox">
                        <SingleImgFileUpload
                            v-bind:saveData="saveData"
                            @set-file="setImgFile"
                        ></SingleImgFileUpload>
                    </div>
                </div>
                <div class="caution-txt" style="font-size: 2.4rem; color:#949494; font-weight: 400;">
                    *링크 또는 업로드 둘 중 하나만 등록 가능합니다.
                </div>
              </div>
  
              <div class="btnBox">
                <button @click="goback()" class="redborderBtn">취 소</button>
                <button @click="videoSubmit" class="redBtn" style="margin-right: 0;">
                  {{ submitText }}
                </button>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  /* import Editor from '@/components/layout/board/Editor' */
  import SingleVideoFileUpload from "@/components/layout/board/SingleVideoFileUpload";
  import SingleImgFileUpload from "@/components/layout/board/SingleImgFileUpload";
  import axios from "@/axios/axios";
  
  export default {
    components: {
      /* Editor, */
      SingleVideoFileUpload,
      SingleImgFileUpload
    },
    data() {
      return {
        linkText:'',
        privateSelected: '전체 공개',
        privateOptions: [
            {text: '전체 공개', value:'A' },
            {text: '회원 공개', value:'B' },
            {text: '비공개 선택', value:'C' },
        ],
        category: 1,
        categoryList: [],
        submitText: "수 정",
        saveData: {
          idx: "",
          title: "",
          content: "",
          file: null,
          fileGroupId: null,
          fileName: null,
          saveFileName: null,
          img: null,
          imgGroupId: null,
          imgName: null,
          imgSaveFileName: null,
          tempImgGroupId: null,
          privateOption: "",
          category: "",
          linkText: ""
        },
      };
    },
    mounted() {
      this.getCategoryList();
      let idx = this.$route.params.idx;
      let param = {
        IDX: idx,
      };
  
      if (idx) {
        axios
          .post("/api/video/getVideoInfo", param)
          .then((response) => {
            if (response.status == 200) {
              let data = response.data.VIDEO;
              this.saveData.idx = data.IDX;
              this.saveData.title = data.TITLE;
              this.saveData.content = data.CONTENT;

              this.saveData.fileGroupId = data.FILE_GROUP_ID;
              this.saveData.fileName = data.REAL_FILE_NAME;
              this.saveData.saveFileName = data.SAVE_FILE_NAME;

              this.saveData.imgGroupId = data.IMG_FILE_GROUP_ID;
              this.saveData.imgName = data.IMG_REAL_NAME;
              this.saveData.imgSaveFileName = data.IMG_NAME;

              this.saveData.tempImgGroupId = data.TEMP_IMG_FILE_GROUP_ID;

              this.saveData.privateOption = data.PRIVATE_OPTION;
              this.saveData.category = data.CATEGORY_IDX;
              if(data.VIMEO_LINK){
                this.saveData.linkText = data.VIMEO_LINK;
              } else if(data.YOUTUBE_LINK) {
                this.saveData.linkText = data.YOUTUBE_LINK;
              }
              
              this.submitText = "수 정";
            }
          })
          .catch((error) => {
            this.$alert(
              "알림",
              `게시글을 불러오는데 실패하였습니다. <br>` +
                error.response.data.error
            );
          });
      }
    },
    methods: {
      getCategoryList() {
      axios.get('/api/video/getCategoryList')
      .then((response) => {
            this.categoryList = response.data
            // console.log("this.categoryList:"+this.categoryList)
            if(this.categoryList == null){
                this.categoryList = [];
            }
            // 첫 번째 항목을 기본값으로 설정
            if (this.categoryList.length > 0) {
                this.category = this.categoryList[0].IDX;
            }
        })
        .catch(() => {
            return []
        });
      },
      goback() {
        this.$router.go(-1);
      },
      
      videoSubmit() {
        let idx = this.saveData.idx;
        let title = this.saveData.title;
        let content = this.saveData.content;
        let file = this.saveData.file;
        let img = this.saveData.img;
        let saveFileName = this.saveData.saveFileName !== undefined ? this.saveData.saveFileName : "";
        let fileName = this.saveData.fileName !== undefined ? this.saveData.fileName : "";
        let imgName = this.saveData.imgName !== undefined ? this.saveData.imgName : "";
        let fileGroupId = this.saveData.fileGroupId !== undefined ? this.saveData.fileGroupId : "";
        let imgGroupId = this.saveData.imgGroupId !== undefined ? this.saveData.imgGroupId : "";
        let tempImgGroupId = this.saveData.tempImgGroupId !== undefined ? this.saveData.tempImgGroupId : "";

        // let fileName = file.name;
        let confirmText = "등록";
        let category = this.saveData.category;
        let privateSelected = this.saveData.privateOption;
        let linkText = this.saveData.linkText !== undefined ? this.saveData.linkText : null;
        // console.log("linkText:"+linkText)
        // console.log("file:"+file)
        console.log("fileGroupId:"+fileGroupId)
        console.log("imgGroupId:"+imgGroupId)
        if (idx) {
          confirmText = "수정";
        }
  
        if (!title) {
          this.$alert("알림", "제목을 작성해주세요.");
          return false;
        }
  
        if (!content) {
          this.$alert("알림", "내용을 입력해주세요.");
          return false;
        }
  
        //링크도 없고, 영상도 없을 경우
        if (!fileName && !linkText){
          this.$alert("알림", "링크 또는 영상 둘 중 하나를 등록해주세요.");
          return false;
        }

        //링크도 없고, 영상도 없고, 썸네일만 있을 경우
        if(!linkText && !fileName && imgName){
          this.$alert("알림", "링크 또는 영상 둘 중 하나를 등록해주세요.");
          return false;
        }

        //링크도 있고, 영상도 있을 경우
        if (fileName && linkText){
          this.$alert("알림", "링크 또는 영상 둘 중 하나만 등록해주세요.");
          return false;
        }

        const formData = new FormData();

        //링크 검사
        if(linkText && !fileName){
          const regex1 = /vimeo\.com\/(\d+)/;
          const match1 = linkText.match(regex1);

          const regex2 = /https:\/\/youtu\.be\/([^?]+)\?si=([^&]+)/;
          const match2 = linkText.match(regex2);

          if (match1) {
              formData.append("vimeoLink", linkText);
          } else if (match2) {
              formData.append("youtubeLink", linkText);
          } else {
              this.$alert("알림", "링크 형식이 올바르지 않습니다.");
              return false;
          }
        }

        if (idx) {
          formData.append("idx", idx);
        }
        formData.append("title", title);
        formData.append("content", content);
        formData.append("uploadFile", file);
        formData.append("uploadImg", img);
        formData.append("categoryIdx", category);
        formData.append("privateOption", privateSelected);
        formData.append("saveFileName", saveFileName);
        formData.append("fileGroupId", fileGroupId);
        formData.append("imgGroupId", imgGroupId);
        formData.append("tempImgGroupId", tempImgGroupId);
        formData.append("fileGroupId", fileGroupId);
        formData.append("tempImgGroupId", tempImgGroupId);
  
        var response = this.$createConfirmResponse();
        this.$confirm(
          "알림",
          `게시글을 ${confirmText}하시겠습니까?`,
          "확인",
          "취소",
          response,
          {
            closed: () => {
              if (response.result) {
                axios
                  .post("/api/admin/video/videoSubmit", formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then((result) => {
                    if (result.status == 200) {
                      this.$alert(
                        "알림",
                        `게시글이 ${confirmText}되었습니다.`,
                        "",
                        {
                          closed: () => {
                            this.$router.push({
                              name: "ageTechServiceDetail",
                              params: { idx: result.data.IDX },
                            });
                          },
                        }
                      );
                    } else {
                      this.$alert(
                        "알림",
                        `게시글이 ${confirmText}에 실패하였습니다.`
                      );
                    }
                  })
                  .catch((error) => {
                    this.$alert(
                      "알림",
                      `게시글 ${confirmText}실패하였습니다. ` +
                        error.response.data
                    );
                  });
              }
            },
          }
        );
      },
      setFile(file) {
        this.saveData.file = file;
      },
      setImgFile(file) {
        this.saveData.img = file;
      },
    },
  };
  </script>


  
<style scoped lang="scss">
    .detailInputBox  {width:100%;}
    .detailInputBox  input {margin-left: 0;}

    .detailInputBox > label {margin-right: 2rem; white-space: nowrap;}
    .detailFileInputBox {width:100%;}
    .detailFileInputBox > div {width:100%; display: flex;}
    .detailFileInputBox > div > div {width : 100%;}
    
    .detailFileInputBox input {width: 100%; }

    .detailFileInputBox label {white-space: nowrap;}
    .linkInputWrap {background-color: #f5f5f5; display: inline-block; padding: 0.6rem 2rem 0.5rem; vertical-align: middle;font-size: 2.4rem;
    line-height: 3.5rem; width: 100%;}
    .linkInput {width: 100%; background-color: #f5f5f5;}
    .selectCustom {min-width:17rem;}
</style>
  